import { resolveBackendOrigin } from '../config/api';

export interface GuestInvoiceDownloadOption {
  invoiceId: number;
  invoiceNo?: string;
  label?: string;
}

export interface GuestInvoiceDownloadPayload {
  available?: boolean;
  invoices?: GuestInvoiceDownloadOption[];
}

export function guestInvoiceDownloadUrl(
  appName: string,
  orderId: number,
  invoiceId?: number
): string {
  const origin = resolveBackendOrigin().replace(/\/$/, '');
  const base = `${origin}/api/restaurants/${encodeURIComponent(appName)}/orders/${orderId}/invoice`;
  if (invoiceId == null) {
    return `${base}?download=1`;
  }
  return `${base}?invoiceId=${invoiceId}&download=1`;
}

export function openGuestInvoiceDownload(appName: string, orderId: number, invoiceId?: number): void {
  const url = guestInvoiceDownloadUrl(appName, orderId, invoiceId);
  window.open(url, '_blank', 'noopener,noreferrer');
}
